import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { useParams } from 'react-router-dom';
import cn from 'classnames';

import Tag from '../components/UIkit/Tag';
import NavigationArrow from '../components/SVG/NavigationArrow';
import { DigitalPlatformSections1 } from '../components/DigitalPlatform1/constants';
import { IProduct } from '../components/DigitalPlatform/items/1MonitoringConstants';
import Button from '../components/UIkit/Button';
import { StoreContext } from '../store';
import SmoothScrollWrapper from '../utils/SmoothScrollWrapper';
import { isBY } from '../store/constants';

import ErrorPage from './ErrorPage/ErrorPage';

function ArticlePage() {
  const { contactUs, video } = React.useContext(StoreContext);
  const { enName } = useParams<{ enName: string }>();
  const [curProduct, setCurProduct] = useState(DigitalPlatformSections1.find(item => item.EnName === enName));

  return <ErrorPage />;
  // if (!curProduct) {
  //   return <ErrorPage />;
  // }
  // return (
  //   <>
  //     <Header2 />
  //     <SmoothScrollWrapper>
  //       {isBY ? <FooterBy1 /> : <Footer1 />}
  //     </SmoothScrollWrapper>
  //   </>
  // );
}

export default ArticlePage;
